import { render } from "./DocumentsUserHeader.vue?vue&type=template&id=763a5797"
import script from "./DocumentsUserHeader.vue?vue&type=script&lang=js"
export * from "./DocumentsUserHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__